import { render } from "./TablePrimes.vue?vue&type=template&id=30562024&scoped=true&ts=true"
import script from "./TablePrimes.vue?vue&type=script&lang=ts"
export * from "./TablePrimes.vue?vue&type=script&lang=ts"

import "./TablePrimes.vue?vue&type=style&index=0&id=30562024&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30562024"]])

export default __exports__